import { Alert } from './models';

/**
 * Sort a list of Alert by date in descending order. If two dates are equals,
 * we sort by name in ascending order.
 * @param {Alert[]} alerts - The list of Alerts to be sorted
 * @return Alert[]
 */
export const sortAlerts = (alerts: Array<Alert>): Array<Alert> =>
    alerts.sort((a, b) => {
        const dateA = new Date(a.lastUpdatedAt);
        const dateB = new Date(b.lastUpdatedAt);

        if (dateA < dateB) {
            return 1; // Sort by date in descending order
        }
        if (dateA > dateB) {
            return -1;
        }
        // Dates are equal, so sort by name in ascending order
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });
